import Splide from '@splidejs/splide';
import runBlazy from './utils/run-blazy';

const toggleNavigation = (splide, navigationSelector) => {
  const navigation = document.querySelector(navigationSelector);
  if (!navigation || !splide) return;

  const totalSlides = splide.length;
  const perPage = splide.options.perPage;

  navigation.classList.toggle('show-nav', totalSlides > perPage);
};

document.addEventListener('DOMContentLoaded', function () {
  runBlazy();

  const initSplide = (selector, options) => {
    const element = document.querySelector(selector);

    if (!element) return null;

    return new Splide(selector, options).mount();
  };

  const bindNavigation = (splide, prevSelector, nextSelector) => {
    if (!splide) return;

    document.querySelector(prevSelector)?.addEventListener('click', () => {
      splide.go('<');
    });

    document.querySelector(nextSelector)?.addEventListener('click', () => {
      splide.go('>');
    });
  };

  const claimSplide = initSplide('.mpDOF-body_claim', {
    destroy: true,
    breakpoints: {
      480: {
        arrows: false,
        pagination: false,
        start: 0,
      },
    },
  });

  const videosSplide = initSplide('.mpDOF-body_video-list', {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: '16px',
    arrows: false,
    pagination: false,
    drag: true,
    rewind: false,

    breakpoints: {
      768: {
        perPage: 2,
        gap: '12px',
        arrows: false,
      },

      480: {
        perPage: 1,
        focus: 'center',
        gap: '12px',
        arrows: false,
        pagination: false,
        padding: {
          left: '24px',
          right: '24px',
        },
      },
    },
  });

  bindNavigation(claimSplide, '#splide-claim-prev', '#splide-claim-next');
  bindNavigation(videosSplide, '#splide-video-prev', '#splide-video-next');

  toggleNavigation(videosSplide, '.mpDOF-body_navigation.videos');

  videosSplide.on('updated resized', () => {
    toggleNavigation(videosSplide, '.mpDOF-body_navigation.videos');
  });
});
